module.exports = __webpack_public_path__ + "img/SketchPng23c7966a2d1963c6b88ae89421a6a417dd7b177ac534af52d26b60f665e3e49f.7f4c216b.png";